import type { ComponentProps } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import type { AnyObject, ITableProps } from "@similarweb/pro-logic-components";
import { Table } from "@similarweb/pro-logic-components";
import { Card } from "@similarweb/ui-components";

import { useMetricsSubtitleFilters } from "../useMetricsSubtitleFilters";

type ITitleProps = ComponentProps<typeof Table.TableTop.Title>;

type TableWidgetProps<T extends AnyObject> = Pick<ITableProps<T>, "data" | "columnConfig" | "isLoading" | "highlightedRowSelector"> &
    Pick<ITitleProps, "title"> & {
        dataAutomation?: string;
    };

export const TableWidget = <T extends AnyObject>({ title, dataAutomation, ...other }: TableWidgetProps<T>) => {
    const { translate } = useTranslate();
    const subtitleFilters = useMetricsSubtitleFilters();

    return (
        <Card data-automation={dataAutomation}>
            <Table<T>
                {...other}
                noData={{
                    title: translate("global.nodata.notavilable"),
                }}
                tableLayout="auto"
            >
                <Table.TableTop key="table-top" borderBottom>
                    <Table.TableTop.Title
                        filters={subtitleFilters}
                        title={title}
                    />
                </Table.TableTop>
            </Table>
        </Card>
    );
};
